import { pageConfig } from '@/common/service/page-config';
import _ from 'lodash';
import { planTypes, trackingPlanTypes } from '@/common/constants';

/**
 *
 * @return {PartnerReferBean}
 */
export const getPartnerRefer = () => {
  return pageConfig.partnerReferral ?? {};
};

/**
 * @description get all tracking plan names for partner promotion
 * @param planList
 * @param groupByPlanCodePlanMap
 * @return {string}
 */
export const getTrackingPlanNames = (planList, groupByPlanCodePlanMap = {}) => {
  return _.chain(planList)
    .reduce((pre, planCode) => {
      const { type, category } = _.get(groupByPlanCodePlanMap, [planCode], {});

      const planTypeKey = planTypes[type];
      const planName = trackingPlanTypes[planTypeKey] ?? type;
      const trackingName = (planName || category) ? `${planName} ${category}` : ''

      return [...pre, trackingName];
    }, [])
    .filter(Boolean)
    .join(',')
    .value();
}
